import React from "react";
import { Link } from "react-router-dom";
import { Fuel, ShieldCheck, Users, Leaf } from "lucide-react";
import Layout from "@/components/layout/Layout";
import AssessmentForm from "@/components/forms/AssessmentForm";

const BENEFITS = [
  { icon: Fuel, title: "Diesel-free TCO model", body: "We model your current L/day, kWh/day and $/kWh — then benchmark against MBESS Energy-as-a-Service." },
  { icon: Leaf, title: "Carbon & ESG scorecard", body: "Receive a tonnes-of-CO₂-avoided calculation ready for your sustainability report." },
  { icon: Users, title: "Engineer-led, not sales-led", body: "A Tratou power-electronics engineer leads the assessment. No high-pressure quotes." },
  { icon: ShieldCheck, title: "Zero obligation", body: "Free, confidential, and only moves forward if the numbers make sense for you." },
];

export default function Assessment() {
  return (
    <Layout>
      <section className="py-28 border-b border-white/10" data-testid="assessment-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">Free · Zero Obligation</span>
          <h1 className="heading-massive mt-4">
            Diesel-Generator <br /><span className="text-tratou-green">Assessment.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-tratou-dim text-lg">
            Share your generator capacity, load profile and project duration. A Tratou engineer will
            model your current spend, project your potential savings, and — where it makes sense —
            book an on-site visit within 10 business days.
          </p>
        </div>
      </section>

      <section className="py-16" data-testid="assessment-benefits">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {BENEFITS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="bg-tratou-deep p-6">
              <Icon className="w-6 h-6 text-tratou-green mb-4" />
              <p className="font-display font-bold">{title}</p>
              <p className="mt-2 text-tratou-dim text-sm">{body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="pt-6 pb-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
          <AssessmentForm />
        </div>
      </section>

      <section className="py-16 border-t border-white/10 text-center">
        <div className="max-w-xl mx-auto px-6">
          <h3 className="heading-section" style={{ fontSize: "1.75rem" }}>Prefer to just talk?</h3>
          <p className="mt-3 text-tratou-dim">We're on WhatsApp, Calendly and the phone.</p>
          <Link to="/contact" className="btn-secondary mt-6 inline-flex" data-testid="assessment-contact-fallback">
            All contact options
          </Link>
        </div>
      </section>
    </Layout>
  );
}
